<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-text class="event-page__modal-card-text pa-0">
				<div>
					<div class="event-page__div-image" :style="{'background-image': 'url(' + event.location.primary_image.image + ')' }">
						<v-container fill-height fluid>
							<v-layout fill-height>
								<v-flex xs6 align-end flexbox>
									<button type="button" class="btn-flat-icon--light" @click="open=false">
										<v-icon medium flat>fal fa-times</v-icon>
									</button>
								</v-flex>
								<v-flex xs6 class="text-xs-right">
									<button type="button" class="btn-flat-icon--light">
										<v-icon medium flat>fal fa-heart</v-icon>
									</button>
								</v-flex>
							</v-layout>
						</v-container>
					</div>
					<div>
						<h3 class="pl-3 pr-3 pt-3">{{ event.location.name }}</h3>
						<p class="pl-3 pr-3">{{ event.location.description }}</p>
					</div>
				</div>
				<div class="pa-3">
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'eventLocationModal',
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('eventLocationModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventLocationModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
